import { defineOperationManifest } from "../define"

export const allergenDetectManifest = defineOperationManifest({
	type: "allergen.detect",
	ability: "ai.detect-allergens",
	usageAbility: "ai.detect-allergens",
	bocLabelKey: "operations.boc.types.allergenDetect",
})
